import type { JSX } from 'react';
import type { NodeKind } from '@netdeck/contracts';
import { Icon, type IconName } from './Icon';

/**
 * Иконки типов объектов — раздел 01.1 макета.
 *
 * Глифы берутся из общей библиотеки (`assets/icons/node-*.svg`): раньше шесть
 * типов из двенадцати рисовались здесь руками, а остальные шесть — общей
 * заглушкой, и на карте склада принтер, ИБП и точка доступа выглядели
 * одинаково. Теперь свой глиф есть у каждого типа из `NODE_KINDS`.
 */
const KIND_GLYPHS: Record<NodeKind, IconName> = {
  pc: 'nodePc',
  server: 'nodeServer',
  cloud: 'nodeCloud',
  camera: 'nodeCamera',
  nvr: 'nodeNvr',
  switch: 'nodeSwitch',
  router: 'nodeRouter',
  printer: 'nodePrinter',
  ap: 'nodeAp',
  nas: 'nodeNas',
  ups: 'nodeUps',
  phone: 'nodePhone',
  label: 'nodeLabel',
  other: 'nodeOther',
};

/** Виды узлов — ключами словаря: подпись собирает интерфейс на своём языке. */
export const NODE_KIND_LABEL_KEYS: Record<NodeKind, string> = {
  pc: 'nodes.kind.pc',
  server: 'nodes.kind.server',
  cloud: 'nodes.kind.cloud',
  camera: 'nodes.kind.camera',
  nvr: 'nodes.kind.nvr',
  switch: 'nodes.kind.switch',
  router: 'nodes.kind.router',
  printer: 'nodes.kind.printer',
  ap: 'nodes.kind.ap',
  nas: 'nodes.kind.nas',
  ups: 'nodes.kind.ups',
  phone: 'nodes.kind.phone',
  label: 'nodes.kind.label',
  other: 'nodes.kind.other',
};

export function NodeIcon({ kind, size = 16 }: { kind: NodeKind; size?: number }): JSX.Element {
  return (
    <span className="flex items-center text-muted" aria-hidden="true">
      <Icon name={KIND_GLYPHS[kind]} size={size} />
    </span>
  );
}
